// extracted by mini-css-extract-plugin
export default {"root":"OAuthSeparator_root__qiJbn","line":"OAuthSeparator_line__q27oF"};